import ApiService from "../axios";
import { API_LAYER_URL } from "../../config";

export const RequestLogsService = {
  async getAll() {
    ApiService.setBaseUrl(API_LAYER_URL);
    return await ApiService.getAll("/api/get-request-logs");
  },
  get(id) {
    return ApiService.get(`/api/supplier/${id}/get`, id);
  },
  async create(params) {
    return await ApiService.post("/api/supplier/create", params);
  },
  update(params) {
    return ApiService.update("/api/supplier/update", params);
  },
  delete(params) {
    return ApiService.post(`/api/supplier/delete`, params);
  }
};



// WEBPACK FOOTER //
// ./src/http/services/request-logs.js